/**
 * Landing query for the Queries tab — the union of the two
 * database-query flavors the ontology carries:
 *
 *   - `:NamedQuery` nodes (Ignition named queries ingested from a
 *     gateway backup), each with the `:Database` it `USES_DATABASE`
 *     and the count of `:Table`s it `USES_TABLE`.
 *   - query-flavored `:Tag` nodes — either Ignition tags with
 *     `ignition_tag_type = 'query'` or registered `db://` data points
 *     with `tag_system = 'db'`. `:QueryTag` is a nodespec label but is
 *     never MERGEd at runtime, so a query is always modeled as a `:Tag`.
 *
 * Both flavors return the same column shape (`node`, `kind`,
 * `database`, `tableCount`) so a single mapper can project either.
 *
 * Drained client-side via `drainCypherRows` (the trailing
 * `SKIP toInteger($skip) LIMIT toInteger($pageSize)` walks the result
 * one page at a time).
 */
export const PLANT_QUERIES_CYPHER = `
            CALL {
              MATCH (nq:NamedQuery)
              OPTIONAL MATCH (nq)-[:USES_DATABASE]->(db:Database)
              OPTIONAL MATCH (nq)-[:USES_TABLE]->(tbl:Table)
              RETURN nq AS node,
                     'named_query' AS kind,
                     db AS database,
                     count(distinct tbl) AS tableCount
              UNION
              MATCH (qt:Tag)
                WHERE qt.tag_system = 'db' OR qt.ignition_tag_type = 'query'
              OPTIONAL MATCH (qt)-[:USES_DATABASE]->(db:Database)
              RETURN qt AS node,
                     'query_tag' AS kind,
                     db AS database,
                     0 AS tableCount
            }
            RETURN node, kind, database, tableCount
            ORDER BY toLower(coalesce(node.name, node.id))
            SKIP toInteger($skip) LIMIT toInteger($pageSize)
          `
